import { createRoot } from "react-dom/client";
import PageNotAvailable from "./PageNotAvailable";
import { GlobalThemeProvider, palette } from "@powerdiary/components-library/lib";

interface IInitialSettings {
    mountPointId: string;
}

const baseStyles = {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
    backgroundColor: palette.dusk["50"],
};

export const renderPageNotAvailable = (settings: IInitialSettings) => {
    const container = document.getElementById(settings.mountPointId);
    const root = createRoot(container);
    root.render(
        <GlobalThemeProvider baseStyles={baseStyles}>
            <PageNotAvailable />
        </GlobalThemeProvider>
    );
};
